module.exports = __webpack_public_path__ + "assets/cfb3546b606cf1a2884c768b4b9e04a5.svg";